import { FlashMessageKeys } from 'helpers/errors/applicationErrors';
import { Translate } from 'next-translate';

const getErrorMessageTranslationString = (errorCode: FlashMessageKeys, t: Translate): string | undefined => {
    const ERROR_MESSAGES: Record<FlashMessageKeys, string> = {
        default: t('Unknown error.'),
        'flash-message': t('Unknown error.'),
        'cart-not-found': t('Cart not found.'),
        'cart-unavailable': t('Your login has expired.'),
        'max-allowed-limit': t('Max allowed limit reached.'),
        'packetery-address-id-invalid': t('Invalid Packetery address id.'),
        'invalid-credentials': t('Invalid credentials.'),
        'invalid-refresh-token': t('Invalid refresh token.'),
        'loyalty-club-points-overdraft': t('Loyalty club point overdraft.'),
        'order-emails-not-sent': t('Automatic order emails was not sent.'),
        'order-empty-cart': t('Cart is empty.'),
        'personal-data-request-type-invalid': t('Invalid request type.'),
        'blog-category-not-found': t('Category not found.'),
        'image-type-invalid': t('Invalid image type.'),
        'order-not-found': t('Order not found.'),
        'unknown-claim-create': t('An error occurred while creating the claim, please contact the administrator.'),
        'unknown-return-create': t('An error occurred while creating the return, please contact the administrator.'),
        'personal-data-hash-invalid': t('Invalid hash.'),
        'product-price-missing': t('Product price is missing.'),
        'promo-code-already-applied': t('PROMO_CODE_ALREADY_APPLIED'),
        'promo-code-at-most-one-percentage': t('PROMO_CODE_AT_MOST_ONE_PERCENTAGE'),
        'promo-code-discount-coupon-already-applied': t('PROMO_CODE_ALREADY_APPLIED_DISCOUNT_COUPON'),
        'reservations-disabled-at-place': t('Reservations are disabled at this place.'),
        'no-result-found-for-slug': t('No result found for slug.'),
        'store-not-found': t('Store not found.'),
        'loyalty-club-points-unverified': t('Loyalty points in this order could not be redeemed.'),
        'loyalty-club-points-changed': t('We have updated your points status, please complete the order again.'),
        'gift-voucher-not-applicable-for-personal-pickup': t('GIFT_CODE_CANNOT_BE_APPLIED_WITH_RESERVATION'),
        'promo-code-does-not-meet-minimum-order-price': t('PROMO_CODE_DOES_NOT_MEET_MINIMUM_ORDER_PRICE'),
        GIFT_CODE_CANNOT_BE_APPLIED_ON_CART_ITEMS: t('GIFT_CODE_CANNOT_BE_APPLIED_ON_CART_ITEMS'),
        'order-stock-availability-error': t(
            'Some of the products are not in sufficient quantity in the given warehouse.',
        ),
        'loyalty-club-points-used-for-voucher': t('Loyalty points are not allowed to be used to purchase vouchers.'),
        'promo-code-available-for-registered-customer-user-only': t(
            'Promo code is available for registered customers only.',
        ),
        'promo-code-not-usable-on-vouchers': t('Promo code cannot be used on vouchers.'),
        'wishlist-not-found': t('Wishlist not found.'),
        'wishlist-item-already-exists': t('Product in wishlist already exists.'),
        'wishlist-item-not-found': t('Product in wishlist not found.'),
        'inactive-account': t('Account is inactive.'),
        'not-confirmed-account': t(
            'Your account is inactive. Please confirm it using the link sent to your email, or register again.',
        ),
        'invalid-account': t('Account is invalid.'),
        'invalid-reset-password-hash': t(
            'The original link is no longer valid. Please have your forgotten password sent to you again.',
        ),
        'customer-default-and-selected-delivery-address-mismatch': t(
            'The delivery address you submitted differs from the one selected in the header. Please either refresh this page or select a delivery address that matches the one in the header.',
        ),
        'already-confirmed-account': t('Account is already confirmed, you can log in.'),
        'not-all-required-gdpr-consents-checked': t('Not all required GDPR consents are checked.'),
        'too-many-requests': t('Too many requests. Try again later.'),
    };

    return ERROR_MESSAGES[errorCode];
};

export const hasErrorMessage = (errorCode: FlashMessageKeys, t: Translate): boolean => {
    return getErrorMessageTranslationString(errorCode, t) !== undefined;
};

export const getErrorMessage = (errorCode: FlashMessageKeys, t: Translate): string => {
    const translationString = getErrorMessageTranslationString(errorCode, t);

    return translationString !== undefined ? translationString : t('Unknown error.');
};
